import qs from 'qs'

export const queryProgramsPage = () => {
  const query = qs.stringify(
    {
      populate: {
        ...queryFragmentSingleTypeDefault
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `programs-page?${query}`
}
